import { validateFirstOrLast, validateEmail } from './misc'
import { fetchGiftCard } from '../services/GraphQlClientService'
import moment from 'moment-timezone'
import querystring from 'query-string'

export const validateGiftCardPurchase = async (
  giftOption,
  giftCardPrice,
  occasion,
  personalMessage,
  recipientFirst,
  recipientLast,
  recipientEmail,
  deliveryMethod,
  deliveryDate,
  deliveryDateUpdated,
  selectedProduct,
  giftCardObject,
  me,
  history,
  section4,
  selectedMarket,
  dispatch
) => {
  const errors = []

  // check form fields and generate errors
  if ((giftOption === 'gift-card' && !giftCardPrice) || (giftOption === 'gift-card' && !Number(giftCardPrice?.price))) {
    errors.push('giftCardPriceError')
  }
  if (giftOption === 'gift-card' && !giftCardObject?.id) {
    try {
      const giftCard = await fetchGiftCard()
      if (giftCard.id) {
        giftCardObject = giftCard
      } else {
        errors.push('giftCardObjectError')
      }
    } catch (e) {
      console.error(e)
      errors.push('giftCardObjectError')
    }
  }
  if (giftOption === 'package' && !selectedProduct) {
    errors.push('selectedProductError')
  }
  if (giftOption === 'gift-card' && !occasion) {
    errors.push('occasionError')
  }
  if (!validateFirstOrLast(recipientFirst)) {
    errors.push('recipientFirstError')
  }
  if (!validateFirstOrLast(recipientLast)) {
    errors.push('recipientLastError')
  }
  if (!validateEmail(recipientEmail)) {
    errors.push('recipientEmailError')
  }
  if (!deliveryMethod) {
    errors.push('deliveryMethodError')
  }
  if (deliveryMethod === 'Email' && !deliveryDateUpdated) {
    errors.push('deliveryDateError')
  }

  // set errors and redirect user focus
  if (errors.length) {
    dispatch({ type: 'SET_ERRORS', fields: errors })

    // final section is greyed out until top sections are complete
    // only errors can exist in recipient info section
    section4.current.scrollIntoView({ scrollBehavior: 'smooth' })

    // old logic
    // if (
    //   (giftOption === 'gift-card' && (!giftCardPrice || !occasion)) ||
    //   (giftOption === 'package' && !selectedProduct)
    // ) {
    //   section3.current.scrollIntoView({ scrollBehavior: 'smooth' })
    // } else {
    //   section4.current.scrollIntoView({ scrollBehavior: 'smooth' })
    // }
    return
  }

  const occasions = [
    { name: 'HOLIDAYS', template: 'gifting-holidays' },
    { name: 'BIRTHDAY', template: 'gifting-birthday' },
    { name: 'ANNIVERSARY', template: 'gifting-anniversary' },
    { name: 'OTHER', template: 'gifting-other' }
  ]

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const checkoutInfo = {
    giftOption,
    from: 'gift-card',
    occasion,
    deliveryDate: moment.tz(deliveryDate, timezone).unix(),
    giftCardPrice,
    recipientFirst,
    recipientLast,
    selectedMarket,
    postData: {
      productId:
        giftOption === 'gift-card' ? giftCardObject.id : selectedProduct.id,
      marketId: selectedMarket?.id,
      amount:
        giftOption === 'package' ? selectedProduct.price : giftCardPrice.price,
      deliverAfter: deliveryDate ? deliveryDate : new Date(),
      recipientName: `${recipientFirst} ${recipientLast}`,
      recipientEmail,
      messageBody: personalMessage,
      messageTemplate: occasions.find(o => o.name === occasion)?.template || 'gifting-other',
      notifyRecipient: deliveryMethod === 'Print' ? false : true
    }
  }

  
  const queryStringInfo = {
    giftOption,
    from: 'gift-card',
    occasion,
    deliveryDate: moment.tz(deliveryDate, timezone).unix(),
    giftCardPrice: JSON.stringify(giftCardPrice),
    recipientFirst,
    recipientLast,
    selectedMarket: selectedMarket?.id,
    postData: JSON.stringify({
      productId:
      giftOption === 'gift-card' ? giftCardObject.id : selectedProduct.id,
      marketId: selectedMarket?.id,
      amount:
      giftOption === 'package' ? selectedProduct.price : giftCardPrice.price,
      deliverAfter: deliveryDate ? deliveryDate : new Date(),
      recipientName: `${recipientFirst} ${recipientLast}`,
      recipientEmail,
      messageBody: personalMessage,
      messageTemplate: occasions.find(o => o.name === occasion)?.template || 'gifting-other',
      notifyRecipient: deliveryMethod === 'Print' ? false : true
    })
  }

  const queryString = querystring.stringify(queryStringInfo)

  //check for user, redirect to checkout and send info via React Router state
  if (!me) {
    history.push(
      `/signin?onSuccess=/checkout/${checkoutInfo.postData.productId}?${queryString}`)
  } else {
    history.push(`/checkout/${checkoutInfo.postData.productId}?${queryString}`)
  }
}
